import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=12149292&scoped=true&"
import script from "./Gift.vue?vue&type=script&lang=js&"
export * from "./Gift.vue?vue&type=script&lang=js&"
import style0 from "./Gift.vue?vue&type=style&index=0&id=12149292&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12149292",
  null
  
)

export default component.exports